/** @jsx jsx */

import { jsx, Flex, Heading, Text, Select } from "theme-ui"
import PropTypes from "prop-types"
import { navigate } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

import theme from "../gatsby-plugin-theme-ui"
import { Layout } from "../components/Layout"
import { Link } from "../components/Link"

const PrevNextArrows = ({ pageNumber, pageSlugs, numPages }) => {
  return (
    <Flex sx={{ justifyContent: "center", fontSize: 3 }}>
      {pageNumber > 1 ? (
        <Link variant="primary" to={pageSlugs[pageNumber - 2]} sx={{ mx: 4 }}>
          {"< Prev"}
        </Link>
      ) : null}
      {pageNumber < numPages ? (
        <Link variant="primary" to={pageSlugs[pageNumber]}>
          {"Next >"}
        </Link>
      ) : null}
    </Flex>
  )
}
PrevNextArrows.propTypes = {
  pageNumber: PropTypes.number,
  numPages: PropTypes.number,
  pageSlugs: PropTypes.arrayOf(PropTypes.string),
}

const ComicPageTemplate = ({ pageContext }) => {
  const { frontmatter, imageData, ogImageData, numPages, pageSlugs } =
    pageContext
  const { title, date, page_number } = frontmatter
  return (
    <Layout
      seoProps={{
        title,
        image: ogImageData.images.fallback.src,
        canonicalUrlPath: pageSlugs[page_number - 1],
      }}
    >
      <div sx={{ ...theme.comicPageStyles.contentContainer }}>
        <Flex
          sx={{
            textAlign: ["center", "center", "left"],
            flexDirection: ["column", "column", "row"],
            alignItems: "center",
            justifyContent: "flex-end",
            mb: 5,
          }}
        >
          <Heading as="h1" sx={{ maxWidth: "45%", fontSize: [3, 3, 4] }}>
            {title}
          </Heading>
          <Text
            variant="subheading"
            sx={{
              ml: [null, null, 5],
              mr: [null, null, "auto"],
              mt: [3, 3, 0],
            }}
          >
            {date}
          </Text>
          <Select
            defaultValue={pageSlugs[page_number - 1]}
            onChange={(e) => {
              navigate(e.target.value)
            }}
            sx={{ pr: [null, null, 5], mt: [4, 4, 0] }}
          >
            {pageSlugs.map((slug) => (
              <option key={slug} value={slug}>
                Page {pageSlugs.indexOf(slug) + 1}
              </option>
            ))}
          </Select>
          <PrevNextArrows
            pageNumber={page_number}
            numPages={numPages}
            pageSlugs={pageSlugs}
          />
        </Flex>
        <GatsbyImage image={imageData} alt={title} />
        <PrevNextArrows
          pageNumber={page_number}
          numPages={numPages}
          pageSlugs={pageSlugs}
        />
      </div>
    </Layout>
  )
}
ComicPageTemplate.propTypes = {
  pageContext: PropTypes.shape({
    imageData: PropTypes.object,
    ogImageData: PropTypes.object,
    frontmatter: PropTypes.shape({
      date: PropTypes.string,
      title: PropTypes.string,
      image: PropTypes.string,
      page_number: PropTypes.number,
    }),
    numPages: PropTypes.number,
    pageSlugs: PropTypes.arrayOf(PropTypes.string),
  }),
}

export default ComicPageTemplate